<div class="mat-card-list">
  @for (item of items(); track item.id; let i = $index) {
    <mat-card class="compact" [class.referred]="isReferred(item)">
      <mat-card-content>
        <mat-card-title class="d-flex justify-content-between align-items-start mat-bold"
                        [class.primary]="usePrimaryText()">
          {{ item.problem }}
          @if (!readonly()) {
            <button
              class="mat-card-button-top-right-corner"
              mat-icon-button
              xuiConfirmationDialog
              [confirmMessage]="'Are you sure you want to remove ' + item.problem + '?'"
              (confirm)="onRemoveItem(item, i)">
              <mat-icon>delete</mat-icon>
            </button>
          }
        </mat-card-title>
        @if (isReferred(item)) {
          <div class="referral-indicator">
            <mat-icon>send</mat-icon>
            <span>{{ getReferralText(item) }}</span>
          </div>
        }
        @if (item.comment) {
          <span class="item-comment">{{ item.comment }}</span>
        }
        <mat-card-subtitle class="d-flex justify-content-between">
          <span>{{ item.lastModifiedDate | date:'yyyy-MM-dd HH:mm' }}</span>
          @if (item.lastModifiedUser) {
            <span>{{ item.lastModifiedUser.firstName }} {{ item.lastModifiedUser.surname }}</span>
          }
        </mat-card-subtitle>
      </mat-card-content>
      <mat-divider></mat-divider>
    </mat-card>
  }

  @if (!hasItems()) {
    <mat-card>
      <mat-card-content>
        <span>{{ emptyMessage() }}</span>
      </mat-card-content>
    </mat-card>
  }
</div>
